import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
export { default } from "dayjs";

dayjs.extend(timezone);
dayjs.extend(utc);
dayjs.extend(customParseFormat);

const DATE_FORMAT = "YYYY-MM-DD HH:mm";

const OPPOSITE_DATE_FORMAT = "MM/DD/YYYY HH:mm";

const DATE_ONLY_FORMAT = "YYYY-MM-DD";

export const toDayJs = (jsonDate) => dayjs(jsonDate).tz();

export const currentTime = () => toDayJs(new Date()).tz();

export const formatFromJsonDate = (jsonDate) =>
  toDayJs(jsonDate).tz().format(DATE_FORMAT);

export const formatFromJsonDateUtc = (jsonDate) =>
  dayjs(jsonDate).utc().format(DATE_FORMAT);

export const oppFormatFromJsonDate = (jsonDate) => {
  if (!jsonDate) return "";
  const date = toDayJs(jsonDate).tz();
  return date.isValid() ? date.format(OPPOSITE_DATE_FORMAT) : "";
};

// Excel export Shipment Status (NEW)
// export const oppToExcelDateTime = (jsonDate) => {
//   if (!jsonDate) return null;
//   console.log("jsonDate", jsonDate);
//   const d = toDayJs(jsonDate).tz(); // keep your timezone behavior
//   console.log("afterJsonDate", d.toString());
//
//   console.log("afterJsonDateFormatFrom", formatFromJsonDate(jsonDate));
//   return d.isValid() ? d.toDate() : null; // <-- key: return Date
// };

const EXCEL_EPOCH_1900 = 25569; // days between 1899-12-30 and 1970-01-01
const MS_PER_DAY = 24 * 60 * 60 * 1000;
/**
 * Converts an instant (jsonDate) into an Excel date serial that represents
 * the COMPANY timezone wall-clock time, independent of system timezone.
 */
export const oppToExcelDateTime = (jsonDate) => {
  if (!jsonDate) return null;
  const c = dayjs(jsonDate).tz(); // uses dayjs.tz.setDefault(companyTz)
  // Build a "timezone-less" timestamp from the company wall-clock components.
  // Using Date.UTC avoids the browser's local timezone.
  const utcLikeMs = Date.UTC(
    c.year(),
    c.month(),
    c.date(),
    c.hour(),
    c.minute(),
    c.second(),
    c.millisecond(),
  );
  return utcLikeMs / MS_PER_DAY + EXCEL_EPOCH_1900;
};

export const formatToDateOnlyFromJsonDate = (jsonDate) =>
  toDayJs(jsonDate).format(DATE_ONLY_FORMAT);

export const fromDayJsToFormatedDate = (dayJsObject) =>
  dayJsObject.format(DATE_FORMAT);

// UTC
export const fromDayJsToJsonDate = (dayJsObject) => dayJsObject.utc().toJSON();

// Comparisons
// The input should be convertable to dayjs object

export const isAfter = (dayJsObject, date2) =>
  dayJsObject.utc().isAfter(dayjs(date2).utc());

export const isBefore = (dayJsObject, date2) =>
  dayJsObject.utc().isBefore(dayjs(date2).utc());

export const isSame = (dayJsObject, date2) =>
  dayJsObject.utc().isSame(dayjs(date2).utc());

// For comparing non day js
export const isAfterJson = (date1, date2) => dayjs(date1).isAfter(dayjs(date2));

export const isBeforeJson = (date1, date2) =>
  dayjs(date1).isBefore(dayjs(date2));

export const subtractHoursToDate = (date, hours) => {
  return dayjs(date).subtract(hours, "hour").toJSON();
};

export const addMinutesToDate = (date, minutes) =>
  dayjs(date).add(minutes, "minutes").toJSON();

export const subtractMinutesToDate = (date, minutes) =>
  dayjs(date).subtract(minutes, "minutes").toJSON(); //returns a dayjs object

export const addMinutesToDateWithoutConvertingToJson = (date, minutes) =>
  dayjs(date).add(minutes, "minutes");

export const subtractMinutesFromDateWithoutConvertingToJson = (date, minutes) =>
  dayjs(date).subtract(minutes, "minutes");

export const splitDateFromDateTime = (dateTime) => {
  if (!dateTime) return null;

  let date = new Date(dateTime);
  date = date.toISOString().split("T")[0];
  return date;
};

export const formatCsvDate = (value) => {
  if (!value) return "";

  const d = dayjs(value);
  if (!d.isValid()) return value;

  const hasTime =
      d.hour() !== 0 || d.minute() !== 0 || d.second() !== 0;

  return hasTime
      ? d.format("MM-DD-YYYY HH:mm")
      : d.format("MM-DD-YYYY");
};
